export default function formatSelector(selectors: string, id: string): string {
  //* I split the selectors by commas and then format each selector individually
  const selectorsList: string[] = selectors
    .split(',')
    .map((selector) => formatSelectorHelper(selector, id))

  function formatSelectorHelper(selector: string, id: string): string {
    selector = selector.trim()
    if (selector.startsWith('.FlowOuter')) selector = '.Flow-EntireFlow' + selector
    else if (
      selector.includes('.ElementType-FlowMain') ||
      selector.includes('.ElementType-FlowPopupOuter')
    ) {
      selector = selector.replace(/\.Flow-EntireFlow/g, '')
      selector = selector.trim()
      selector = '.Flow-EntireFlow' + selector + ', .Flow-EntireFlow ' + selector
    } else {
      /* Check for any of the top level classes and don't add a space if not necessary */
      const starting = selector.split(' ')[0]
      const addPrefix = !starting.includes('.Flow-EntireFlow')
      if (addPrefix) {
        const startingFlowClasses = getTopFlowClasses(id).filter((cl) => cl !== 'Flow-Element')
        let addSpace = true
        startingFlowClasses.forEach((cl) => {
          if (starting.includes(cl)) addSpace = false
        })
        const prefix = addSpace ? '.Flow-EntireFlow ' : '.Flow-EntireFlow'
        selector = prefix + selector
      }
    }

    selector = selector.replace(/\.Flow-EntireFlow/g, `.Flow-EntireFlow.id-${id}`)
    return selector
  }

  const finalSelector = selectorsList.join(', ')
  return finalSelector
}

export function getTopFlowClasses(flowId: string): string[] {
  const startingFlowClasses = [
    `SignpostForm`,
    `Flow-EntireFlow`,
    `FlowOuter`,
    `Flow-Element`,
    `ElementType-FlowMain`,
    `styleguide`,
    `Builder-V3`,
    `id-${flowId}`,
  ]
  return startingFlowClasses
}

// .SignpostForm.field-value-card_color-white div.component.Container.component-key-card
